import styled from 'styled-components';
import TextInput from 'components/text-input';
import { ReactComponent as _Info } from 'styles/icons/info.svg';
import { color, typography } from 'styles/settings';

export const NameInput = styled(TextInput)`
  resize: none;
  background-color: transparent;
  width: 100%;
  ${typography.font.title.bold};
  font-size: ${typography.size.xxxl};
  min-height: 81px;
  color: ${color.neutral.plainBlack};
  outline: none;

  ::placeholder {
    color: ${color.neutral.plainBlack};
    opacity: 0.4;
  }
`;

export const ReadOnlyMessage = styled.div`
  cursor: help;
  background-color: ${color.neutral.grayLight};
  border-radius: 100px;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px 20px;
  box-sizing: border-box;
`;

export const Info = styled(_Info)`
  width: 16px;
  height: 16px;
  margin-right: 16px;
`;
